<template>
    <div id="app">
        <Header></Header>
        <router-view></router-view>
    </div>
</template>

<script>
import Header from '@/common/mobile/Header.vue';
// import { get } from '@/http/request'
export default {
    components: {
        Header
    },
    data() {
        return {
        }
    },
    mounted() {
        // this.checkDevice()
    },
    beforeDestroy() {
    },
    methods: {
        // async checkDevice() {
        //     const res = await get('/common/getConfig')
        //     if (res.code == 1) {
        //         console.log(res.data, '基础数据');
        //         localStorage.setItem('kefu', res.data.kefu)
        //         this.$store.commit('setLangList', res.data.langList)
        //         if (!localStorage.getItem('defaultLang')) {
        //             this.$store.commit('setDefaultLang', res.data.defaultLang)
        //         }
        //         localStorage.setItem('shareUrl', res.data.share_url)
        //         return
        //     }
        //     this.$toast(res.msg);
        // }
    }
}
</script>
<style lang="less" scoped>
#app {
    background-color: #000 !important;
    min-height: 100vh;
}

/* 整体背景 & 字体颜色 */
::v-deep(.van-picker) {
    background-color: #000;
    /* 黑色背景 */
    color: #fff;
    /* 默认文字白色 */
}

::v-deep(.van-picker__toolbar) {
    background-color: #000;
    color: #fff;
    border-bottom: 1px solid #333;
}

::v-deep(.van-picker__title) {
    color: #fff;
}

::v-deep(.van-picker__confirm),
::v-deep(.van-picker__cancel) {
    color: #fff;
}

::v-deep(.van-picker-column__item--selected) {
    color: #fff !important;
    font-weight: bold;
}

::v-deep(.van-picker-column__item) {
    color: #fff !important;
    font-weight: bold;
}

::v-deep .van-cell {
    background-color: #000;
}

::v-deep .van-field__control {
    color: #fff;
}

::v-deep(.van-picker__mask) {
    background-image: linear-gradient(180deg,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0.4)),
        linear-gradient(0deg,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0.4)) !important;
}

::v-deep(.van-picker__frame) {
    border: 0.2px solid #1d1d1d;
}
</style>
